import { ParsingCommentsDataBundlePropType } from "@interfaces/data-type/type.pages-comments";
import { Dispatch,FoxIcon,OwnIcon,StoragesSystem,  } from "index-module";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { HeaderGlobal } from "@module-layout/header/index.header.global";
import { FooterGlobal } from "@module-layout/footer/index.footer.global";
import { OwnImage } from "@img/module-images";
import { MyApps } from "./module/MyApps";
import { ApiBody, BASE_URL, ServerRequest } from "@utils/utils-server-request";
import { ContentLoader } from "@module-layout/loader/ContentLoader";

export interface ScreenHomePropTypeSmall {
  StoragesSystem: any,
  setStorage?: (obj: ParsingCommentsDataBundlePropType) => void
}

export type ScreenHomePropType = ScreenHomePropTypeSmall & RouteComponentProps;

const TABS = [
  {
    title: 'OVER VIEW',
    icon: 'file-text',
  },
  {
    title: 'GALLERY',
    icon: 'image'
  }
]

const MENU = [
  {id: '#apps_recent', className: "oneleft onehide-l", label: "Store", href: "/ridwan/store"},
  {id: '#apps_recent', className: "oneleft onehide-l", label: "Recents App"},
  {id: '#why-us', className: "oneleft onehide-l", label: "Why Us"},
  {id: '#contact', className: "oneleft onehide-l", label: "Contact"},
  {id: 'menu', className: "oneright menubtn", label: "", icon: "menu", isMenu: true},
  //{id: 'menu', className: "oneright onehide-l", label: "", icon: "search"},
  {id: 'ridwan', className: "oneright onehide-l", label: "", icon: "ridwan2", href: "/ridwan"},
  {id: 'foxdreem', className: "oneright onehide-l", label: "Foxdreem", icon: "foxdreem", href: "/"}
]

class ScreenView extends Component<any,  any> {
  static defaultProps = {};
  constructor(props: any){
    super(props)
    this.state = {
      appItem: {},
      isFound: false, isError: false, isFetching: false,
      activeTab: 0,
      activeIndex: 0,
    }
  }

  logo = () => (
    <a href="/ridwan/store" className="title titleimg oneleft" hrefLang="en"><img src={OwnImage.FoxStoreIconWhite} />
      <label className="title ">
        <span style={{fontWeight: 'bold', color: '#fff'}}>fox</span>
        <span style={{fontWeight: 200}}>store</span>
        <span className="onetm">TM</span>
        </label>
    </a>
  )

  componentDidMount(): void {
    console.log(this.props.location.search.replace('?id=',''));
    const id = this.props.location?.search?.replace?.('?id=','')
    this.getDataDetails(id)
  }

  getDataDetails = (id: string) => {
    const config: ApiBody  = {
      endpoint: `api/app_${id}.json`,
    }
    if(!this.state.isFetching){
      this.setState({isFetching: true})
      new ServerRequest(BASE_URL).get( config, ({data, isFound, isError, isFetching}) =>{
        if(isFound){
          this.setState({ isFound, isError, isFetching, appItem: data})
        }else if(isError){
          this.setState({ isFound, isError, isFetching})
        }
      })
    }
  }

  onClick = (index: number) => {
    this.setState({activeTab: index})
  }
  onClickImage= (index:number) => {
    this.setState({activeIndex: index})
  }
  render(){
    const { props, state } = this;
    const appItem = state.appItem || {}
    return(
      <>
        <HeaderGlobal topMenu = {MENU} logo = {this.logo} / >
          <section style={{backgroundColor: '#e6e6e6'}}>
            <ContentLoader arrLength = {5}  isShow = {state.isFetching} height = {"20%"} />
            { state.isFound &&
              <>
                <div className="onecol" id="slider" style={{}}>
                  <div className="backimg after2 slide25" style={{backgroundImage: `url(${OwnImage.Back6})`, minHeight: "330px"}} >
                    <div className="m1 oneinfo absolute" style={{paddingTop: '100px'}}>
                      <div className="texttitle" style={{display: 'inline-block', padding: '15px', borderRadius: '3px'}}>{appItem.title}</div>	
                      <div style={{paddingTop: '15px', fontSize: '.8em'}} className="onec-blue">{appItem.tech}</div>				
                    </div>
                  </div>
                </div>
              
                <div className="oneitem-info onecol onebg-gray-85 onecontainer" style={{justifyContent: 'center', display: 'flex', backgroundColor: 'transparent', marginTop: '-130px', position: 'relative', zIndex: 2}}>
                  <div className="l3 oneleft">
                    <div className="img" style={{backgroundImage: `url(${appItem?.image?.[0]?.src})` }}></div>
                  </div>
                  {/* <div className="l66 oneleft">
                    <div className="l1">
                      {appItem.desc}
                    </div>			
                  </div> */}
                </div>

                <div className="oneitem-btn onecol onebg-gray-85 onecontainer fexbox" style={{justifyContent: 'center'}}>
                  {TABS.map((item: any, i: number) => (
                    <div onClick={()=> this.onClick(i)} className={`s4 oneleft btn  onehover-semiorange ${state.activeTab != i ? 'oneborder-left': 'onebg-white'}`} id="onerequermentbtn" key = {i}>
                      <div className="oneicon icon one-enter" />
                      <FoxIcon icon = {item.icon} className="oneicon icon one-enter" style={{fontSize: '1.5em',}}  />
                      <div className="text">{item.title}</div>
                    </div>
                  ))}
                </div>

                <div id="oneindex" className="onebg-white">
                  { state.activeTab == 0 &&
                    <div className="onecol look" id="oneoverview">
                      <div className="m1 oneinfo">
                        <div className="onetitle onec-blue">Over View</div>
                        <div>{appItem.client}</div>
                      </div>
                      <div className="pad-bot">
                        <div className="onecol onecontent textview">
                          <div className="l1 oneleft text" style={{paddingBottom: '60px'}}>
                            <div className="title onec-orange" style={{marginBottom: '20px'}}>Description</div>
                            <p style={{whiteSpace: 'pre-line'}} dangerouslySetInnerHTML={{__html: appItem.desc}}></p>		
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  
                  { state.activeTab == 1 &&
                    <div className="onecol look" id="galery">
                      <div className="m1 oneinfo">
                        <div className="onetitle onec-blue">Galery</div>
                        {/* <div>There's so many feature on this app</div> */}
                      </div>
                      <div className="pad-bot">
                        <div className="imglist fexbox">
                          { appItem?.image?.map((item: any, i: number) => (
                            <div className="infoimgsize oneleft childflex list" key={i} onClick={() => this.onClickImage(i)}>
                              <div className="box shadow onebg-purple" style={i == state.activeIndex ? {transform: 'scale(.8)'} : {}}>
                                <div className="backimg imglook" style={{backgroundImage: `url(${item.src})`}}></div>						
                                <img src={OwnImage.SecretImgSort} style={{width: '100%'}} />
                              </div>
                            </div>			
                          ))}
                        </div>	
                        <div className="imgview">
                          <div className="box" style={{maxWidth: '680px', margin:'auto'}}>
                            <img src={appItem?.image?.[state.activeIndex]?.src} style={{width: '100%'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              
              </>
            }


            <div className="onecol onebg-semiblack" style={{textAlign: 'center'}} id="apps_recent">
              <div className="backimg after3 onecontainer" style={{backgroundImage: `url(${OwnImage.BackTrans})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">Maybe You Interesting</div>
                </div>
                <div className="applist onecol fexbox foxapps absolute" style={{backgroundColor: 'transparent'}} id="apps_lib">
                  <MyApps api = {"recent_apps"} />
                </div>
                <div className="onecontainer btnmore absolute">
                  <label className="onec-blue">Get More Apps</label><a className="oneclick-orange  mar-side onehover" href="/ridwan/store/">VIEW ALL</a> 
                </div>
              </div>
            </div>

          </section>
        <FooterGlobal {...props}  />
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
  StoragesSystem: state.StoragesSystem,
})
const mapDispatchToProps = (dispatch: Dispatch ) => ({
  setStorage: ({ data, type }: ParsingCommentsDataBundlePropType) => dispatch( new StoragesSystem().setStorage({ data, type }) ),
})

export default withRouter(connect( mapStateToProps, mapDispatchToProps )( ScreenView ));
